<footer class="d-flex flex-column align-items-center">
  <ps-link
    [route]="'tel:' + contactRef"
    class="mb-1"
    ariaLabel="Call PureSpectrum support"
    >{{ contactLabel }}</ps-link
  >
  <p class="text-center text-copyright">
    Copyright &copy; {{ year }} - {{ companyName }} - All rights reserved
  </p>
</footer>
